/**
 * 小程序 rpx → 浏览器 px（750 设计宽与视口宽度对齐）。
 * 纯 Vue H5 无 uni 运行时，模板内联样式中的 "NNrpx" 在 Safari 等为非法单位，须转为 px。
 *
 * @param {number|string} rpxVal 设计稿上的 rpx 数值
 * @param {number} [windowWidthPx] 视口 CSS 宽度；缺省取 window.innerWidth
 * @returns {string} 如 "12.5px"
 */
export function rpxToPx(rpxVal, windowWidthPx) {
  const n = typeof rpxVal === 'string' ? parseFloat(rpxVal) : Number(rpxVal)
  if (!Number.isFinite(n)) return '0px'
  const w =
    windowWidthPx != null && Number.isFinite(Number(windowWidthPx))
      ? Number(windowWidthPx)
      : typeof window !== 'undefined'
        ? window.innerWidth || 375
        : 375
  const px = (n / 750) * w
  return `${Math.round(px * 1000) / 1000}px`
}
